import { schema } from 'normalizr';

export const schedule = new schema.Entity('schedules');
export const schedules = [schedule];
